"use client";

import Counter from "../../../../components/Counter";
import FormInput from "../../../../components/FormInput";
import detailStyles from "../../css/inventoryItemDetail.module.css";

export default function StockRequestQuantityRow({
  isRequestFlow,
  quantity,
  setQuantity,
  viewValue,
  viewName,
}) {
  return (
    <div className={detailStyles.field}>
      <label>Quantity</label>
      {isRequestFlow ? (
       <Counter value={quantity} onChange={setQuantity} min={1} dynamicWidth={true} />
      ) : (
        <FormInput
          label=""
          type="text"
          name={viewName}
          value={viewValue != null ? String(viewValue) : ""}
          onChange={() => {}}
        />
      )}
    </div>
  );
}
